/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_AnaliticaInspecciones as AnaliticaInspecciones,
  rec_Componente_LC_76_67 as Componente_LC_76_67,
  rec_DetalleActa as DetalleActa,
  rec_EstadoError as EstadoError,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_F1 as F1,
  rec_FormularioActa as FormularioActa,
  rec_I1 as I1,
  rec_IniciarInspeccion as IniciarInspeccion,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_On as On,
  rec_Pr as Pr,
  rec_R1 as R1,
  rec_React as React,
  rec_api as api,
  rec_w1 as w1,
} from "../../runtime/index.jsx";
import { MedicionConcesionarias } from "./MedicionConcesionarias.jsx";
export function ListaInspecciones() {
  let [e, t] = (0, React.useState)(null),
    [n, r] = (0, React.useState)([]),
    [i, a] = (0, React.useState)([]),
    [o, s] = (0, React.useState)(0),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(null),
    [h, g] = (0, React.useState)(null),
    [_, v] = (0, React.useState)(null),
    [y, b] = (0, React.useState)(null),
    x = (0, React.useRef)(crypto.randomUUID()),
    S = (0, React.useCallback)(async () => {
      f(``);
      try {
        let [e, n, i, s] = await Promise.all([
          api(`/inspecciones/plantillas`),
          api(`/inspecciones?pagina=${o}&buscar=${encodeURIComponent(c)}`),
          api(`/fundos`).catch(() => []),
          api(`/inspecciones/constancia`, {
            sinCache: !0,
          }).catch(() => null),
        ]);
        (t(e), a(n), r(i ?? []), b(s));
      } catch (e) {
        f(e.message);
      }
    }, [o, c]);
  (0, React.useEffect)(() => {
    S();
  }, [S]);
  async function C(e, t, n, k) {
    try {
      f(``);
      let r = await api(`/inspecciones`, {
        method: `POST`,
        body: JSON.stringify({
          plantillaId: e,
          unidadId: t,
          fundoId: n,
          concesionariaId: k ?? null,
          clave: x.current,
        }),
      });
      (g(r), m(null), (x.current = crypto.randomUUID()));
    } catch (e) {
      f(e.message);
    }
  }
  async function w(e) {
    try {
      f(``);
      let t = await api(`/inspecciones/${e}`);
      t.estado === `CERRADA` ? v(t) : g(t);
    } catch (t) {
      (t.status === 404 && w1(e), f(t.message));
    }
  }
  let [T, E] = On(),
    D = Number(T.get(`acta`)) || null,
    O = (0, React.useRef)(w);
  ((0, React.useEffect)(() => {
    O.current = w;
  }),
    (0, React.useEffect)(() => {
      D &&
        (O.current(D),
        E(
          {},
          {
            replace: !0,
          },
        ));
    }, [D, E]));
  function k(e) {
    let t = e.unidades.length === 1 ? e.unidades[0].id : null,
      r = n.length === 1 ? n[0].id : null;
    t && (r || !n.length) ? C(e.id, t, r) : m(e);
  }
  return (
    <EstructuraPrincipal
      title={`Inspecciones`}
      accionesRapidas={!1}
      children={
        <div
          className={`mx-auto flex w-full max-w-5xl flex-col gap-3 pb-8`}
          children={[
            <EstadoError mensaje={u} onReintentar={S} />,
            h ? (
              <FormularioActa
                key={h.id}
                inicial={h}
                onSalir={() => {
                  (g(null), S());
                }}
              />
            ) : (
              <JSXRuntime.Fragment
                children={[
                  <p
                    className={`text-sm text-(--text)`}
                    children={`Revisa, registra lo encontrado y firma el acta desde tu celular.`}
                  />,
                  e ? (
                    <JSXRuntime.Fragment
                      children={[
                        p ? (
                          <IniciarInspeccion
                            plantilla={p}
                            fundos={n}
                            onVolver={() => m(null)}
                            onComenzar={C}
                          />
                        ) : (
                          <div
                            className={`grid gap-3 sm:grid-cols-3`}
                            children={e.map((e) => (
                              <button
                                key={e.id}
                                className={`${I1} animar-entrada flex min-h-14 flex-row flex-wrap items-center gap-2 text-left transition active:scale-[0.97] focus-visible:ring-2 focus-visible:ring-(--accent-border)`}
                                onClick={() => k(e)}
                                children={[
                                  <Pr
                                    className={`h-5 w-5 shrink-0 text-(--accent)`}
                                  />,
                                  <span
                                    className={`text-sm font-medium text-(--text-h)`}
                                    children={e.nombre}
                                  />,
                                  <span
                                    className={`w-full text-xs text-(--text)`}
                                    children={[
                                      e.contenido.items.length,
                                      ` puntos de revisión`,
                                    ]}
                                  />,
                                ]}
                              />
                            ))}
                          />
                        ),
                        <section
                          className={`flex flex-col gap-3`}
                          children={[
                            <h2 className={R1} children={`Actas del equipo`} />,
                            <input
                              aria-label={`Buscar actas`}
                              className={F1}
                              placeholder={`Buscar acta, grupo, fundo o responsable…`}
                              maxLength={120}
                              value={c}
                              onChange={(e) => {
                                (l(e.target.value), s(0));
                              }}
                            />,
                            i.length ? (
                              <div
                                className={`max-h-[34rem] overflow-y-auto rounded-2xl border border-(--border)`}
                                children={[
                                  <ul
                                    className={`divide-y divide-(--border) sm:hidden`}
                                    children={i.map((e) => (
                                      <li
                                        key={e.id}
                                        className={`p-3`}
                                        children={[
                                          <AccionAsync
                                            variante={`texto`}
                                            className={`min-h-11 w-full justify-start text-left`}
                                            onClick={() => w(e.id)}
                                            children={[e.nombre, ` · #`, e.id]}
                                          />,
                                          <p
                                            className={`text-xs text-(--text)`}
                                            children={[
                                              e.unidadNombre,
                                              e.fundoNombre,
                                              e.estado === `CERRADA`
                                                ? `Firmada`
                                                : `Borrador`,
                                            ]
                                              .filter(Boolean)
                                              .join(` · `)}
                                          />,
                                        ]}
                                      />
                                    ))}
                                  />,
                                  <table
                                    className={`hidden w-full text-left text-sm sm:table`}
                                    children={[
                                      <thead
                                        className={`sticky top-0 bg-(--panel) text-xs uppercase text-(--text)`}
                                        children={
                                          <tr
                                            children={[
                                              `Acta`,
                                              `Grupo`,
                                              `Fundo`,
                                              `Responsable`,
                                              `Estado`,
                                            ].map((e) => (
                                              <th
                                                key={e}
                                                className={`p-3 font-medium`}
                                                children={e}
                                              />
                                            ))}
                                          />
                                        }
                                      />,
                                      <tbody
                                        children={i.map((e) => (
                                          <tr
                                            key={e.id}
                                            className={`border-t border-(--border)`}
                                            children={[
                                              <td
                                                className={`p-2`}
                                                children={
                                                  <AccionAsync
                                                    variante={`texto`}
                                                    className={`min-h-11 text-left`}
                                                    onClick={() => w(e.id)}
                                                    children={[
                                                      e.nombre,
                                                      ` · #`,
                                                      e.id,
                                                    ]}
                                                  />
                                                }
                                              />,
                                              <td
                                                className={`p-2`}
                                                children={e.unidadNombre}
                                              />,
                                              <td
                                                className={`p-2`}
                                                children={e.fundoNombre || `—`}
                                              />,
                                              <td
                                                className={`p-2`}
                                                children={e.inspector}
                                              />,
                                              <td
                                                className={`p-2`}
                                                children={
                                                  e.estado === `CERRADA`
                                                    ? `Firmada`
                                                    : `Borrador`
                                                }
                                              />,
                                            ]}
                                          />
                                        ))}
                                      />,
                                    ]}
                                  />,
                                ]}
                              />
                            ) : (
                              <p
                                className={`${I1} text-sm text-(--text)`}
                                children={`Todavía no hay actas en esta página. Elige una inspección para comenzar.`}
                              />
                            ),
                            <div
                              className={`flex items-center justify-between gap-2`}
                              children={[
                                <AccionAsync
                                  variante={`secundario`}
                                  className={`min-h-11`}
                                  disabled={o === 0}
                                  onClick={() => s(o - 1)}
                                  children={`Anterior`}
                                />,
                                <span
                                  className={`text-xs`}
                                  children={[`Página `, o + 1]}
                                />,
                                <AccionAsync
                                  variante={`secundario`}
                                  className={`min-h-11`}
                                  disabled={i.length < 20}
                                  onClick={() => s(o + 1)}
                                  children={`Siguiente`}
                                />,
                              ]}
                            />,
                          ]}
                        />,
                        <AnaliticaInspecciones constancia={y} />,
                        <MedicionConcesionarias />,
                      ]}
                    />
                  ) : (
                    !u && <Componente_LC_76_67 />
                  ),
                ]}
              />
            ),
            _ && (
              <Modal
                titulo={`${_.nombre} · #${_.id}`}
                onClose={() => v(null)}
                children={<DetalleActa acta={_} datos={_.respuestas} />}
              />
            ),
          ]}
        />
      }
    />
  );
}
